export const FieldType = {
  id: 'id',
  wishGoalId: 'wishGoalId',
  name: 'name',
  personId: 'personId',
  isDesired: 'isDesired',
  order: 'order',
  comment: 'comment',
} as const;
